var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('div',{staticClass:"imageContainer m-0 p-0"},[_c('b-img',{staticClass:"border border-primary",attrs:{"src":_vm.url + _vm.image.url,"width":"150"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }